import React, { PureComponent } from "react";
import { Table, Progress } from "reactstrap";
import UserResult from "./UserResult";
import UserInvitaitonModal from "./UserInvitationModal";
import BusinessRoleModal from "./BusinessRoleModal";
import withAlertTimeout from "../../../HOCs/withAlertTimeout";
import Alert from "../../Widgets/Alert";

class UserList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      businessRoleModalOpen: false,
      selectedUser: null
    };

    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
    this.onFailure = this.onFailure.bind(this);
    this.closeBusinessRoleModal = this.closeBusinessRoleModal.bind(this);
  }

  showModal(user) {
    return () => {
      this.setState({ modalOpen: true, selectedUser: user });
    };
  }

  showBusinessRoleModal(user) {
    return () => {
      this.setState({ businessRoleModalOpen: true, selectedUser: user });
    };
  }

  closeModal() {
    this.setState({ modalOpen: false, selectedUser: null });
  }

  closeBusinessRoleModal() {
    this.setState({ businessRoleModalOpen: false, selectedUser: null });
  }

  renderUsers() {
    const { allIds, byId } = this.props.users;
    return allIds.map(id => {
      return (
        <UserResult
          onSuccess={this.onSuccess}
          onFailure={this.onFailure}
          showModal={this.showModal(byId[id])}
          showBusinessRoleModal={this.showBusinessRoleModal(byId[id])}
          closeModal={this.closeModal}
          key={id}
          user={byId[id]}
          onRemoveClick={this.props.onRemoveClick}
        />
      );
    });
  }

  onSuccess() {
    this.closeModal();
    this.props.showSuccess();
  }

  onFailure() {
    this.closeModal();
    this.props.showFailure();
  }

  render() {
    return [
      <UserInvitaitonModal
        open={this.state.modalOpen}
        close={this.closeModal}
        user={this.state.selectedUser}
        key="modal"
        onSuccess={this.onSuccess}
        onFailure={this.onFailure}
      />,
      <BusinessRoleModal
        open={this.state.businessRoleModalOpen}
        close={this.closeBusinessRoleModal}
        user={this.state.selectedUser}
        key="rolemodal"
        onSuccess={this.onSuccess}
        onFailure={this.onFailure}
      />,
      <Alert key="success" active={this.props.success} message="Success" />,
      <Alert
        key="error"
        type="danger"
        active={this.props.failure}
        message="Something went wrong, please try again"
      />,
      <Table
        hover
        responsive
        className="table-outline mb-0 d-none d-sm-table user-table"
        key="table"
      >
        <thead className="thead-light">
          <tr>
            <th className="text-center">
              <i className="icon-people" />
            </th>
            <th>User</th>
            <th>Email</th>
            <th className="text-center">Role</th>
          </tr>
          {this.renderUsers()}
        </thead>
        <tbody />
      </Table>
    ];
  }
}

export default withAlertTimeout(UserList);



// WEBPACK FOOTER //
// ./src/views/Pages/Users/UserList.js